const apiList = {
  website: {
    media_picture: 'website/media_picture',
    listByMedia: 'website/list-by-media',
    articles: {
      index: 'website/articles/index',
      store: 'website/articles/store',
    },
    pictures:{
      upload: 'website/pictures/upload',
      getPictures: 'website/pictures',
    },
    dev: {
      index: 'website/dev/index',
      store: 'website/dev/store',
    },
    honors:{
      store: 'website/honors/store',
      index: 'website/honors/index',
    },
    tencent:{
      store: 'website/tencent/store',
      index: 'website/tencent/index',
    }
  }

}


export default apiList